import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Avatar, Box, Skeleton, TextField, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { useProfileData } from "../../../../../../hooks/useProfileData";
import APP_ROUTES from "../../../../../../routers/routeConstants";

import { ChallengeIcon, EventIcon, PostIcon, ServiceIcon } from "../../../../assets/icons/create-feed";

const buttonStyle = {
  color: "#111",
  fontFamily: "Montserrat",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "20px",
  flex: 1,
};

const CreateFeed = () => {
  const [postDescription, setPostDescription] = useState<string>("");
  const { t } = useTranslation("feed", { keyPrefix: "createFeed" });
  const navigate = useNavigate();

  const { data: userData, isLoading } = useProfileData();
  const { firstTwoChr, media } = userData;

  const handleFocus = () => {
    navigate(APP_ROUTES.CREATE_POST);
  };

  const handleCreateEvent = () => {
    navigate(APP_ROUTES.CREATE_EVENT);
  };

  const handleCreateService = () => {
    navigate(APP_ROUTES.CREATE_SERVICE);
  };

  const postTypes = [
    {
      icon: <ChallengeIcon />,
      label: t("challenge"),
      action: null,
    },
    {
      icon: <EventIcon />,
      label: t("event"),
      action: handleCreateEvent,
    },
    {
      icon: <ServiceIcon />,
      label: t("service"),
      action: handleCreateService,
    },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        padding: "16px",
        borderRadius: "8px",
        border: "1px solid #E7E7E7",
        background: "rgba(255, 255, 255, 0.90)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: "8px",
        }}
      >
        <Avatar sx={{ width: "40px", height: "40px" }} src={isLoading ? undefined : media}>
          {isLoading ? <Skeleton variant="circular" animation="wave" /> : firstTwoChr}
        </Avatar>
        <TextField
          placeholder={t("startPost")}
          variant="outlined"
          value={postDescription}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setPostDescription(event.target.value);
          }}
          onFocus={handleFocus}
          sx={{
            width: "100%",
          }}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          gap: "8px",
        }}
      >
        {postTypes.map(({ icon, label, action }, index) => (
          <Button key={index} startIcon={icon} sx={buttonStyle} disabled={!action} onClick={action ?? undefined}>
            {label}
          </Button>
        ))}
      </Box>
    </Box>
  );
};

export default CreateFeed;
